type ClipboardWriter = Pick<Clipboard, 'writeText'>;

function getNavigatorClipboard(): ClipboardWriter | undefined {
  return typeof navigator === 'undefined' ? undefined : navigator.clipboard;
}

export async function copyTextToClipboard(
  text: string,
  clipboard: ClipboardWriter | null | undefined = getNavigatorClipboard()
): Promise<boolean> {
  if (!clipboard) return false;
  try {
    await clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
